
import { supabase } from "@/integrations/supabase/client";
import { ReagentRequest } from "@/types/reagentRequest.types";
import { createLogger } from "@/services/utils/loggingUtils";

const logger = createLogger("RequestsBaseService");

// Fetch profile for a request
export const fetchRequestProfile = async (userId: string) => {
  if (!userId) return null;
  
  const { data, error } = await supabase
    .from("profiles")
    .select("*")
    .eq("id", userId)
    .eq("approval_status", "approved")
    .neq("is_deleted", true)
    .maybeSingle();
  
  if (error) {
    logger.error("Error fetching profile for request:", error);
    return null;
  }
  
  return data;
};

// Fetch category for a request
export const fetchRequestCategory = async (categoryId: string) => {
  if (!categoryId) return null;
  
  const { data, error } = await supabase
    .from("categories")
    .select("*")
    .eq("id", categoryId)
    .single();
  
  if (error) {
    logger.error("Error fetching category for request:", error);
    return null;
  }
  
  return data;
};

// Enhance request with profile and category data
export const enhanceRequestWithRelations = async (request: any): Promise<ReagentRequest> => {
  // Fetch profile for this request
  const profileData = await fetchRequestProfile(request.user_id);
  
  // Fetch category for this request
  const categoryData = await fetchRequestCategory(request.category_id);
  
  // Return enhanced request
  return {
    ...request,
    profiles: profileData,
    categories: categoryData
  } as ReagentRequest;
};
